// extracted by mini-css-extract-plugin
export default {"footer":"EventFooter_footer__z9LBD","btn":"EventFooter_btn__PKZfJ"};